import gql from 'graphql-tag';

export default gql`
fragment UserBillingAddressFragment on UserBillingAddress {
    id
    name
    postcode
    city
    street
    house_number
    is_default
    vat_number
    is_company
    bank_transfer_enabled
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserBillingAddressFragment.ts